<template>
    <div class="login-container">
        <!-- 背景装饰 -->
        <div class="login-background">
            <div class="login-decoration-circle circle-1"></div>
            <div class="login-decoration-circle circle-2"></div>
            <div class="login-decoration-circle circle-3"></div>
            <div class="login-decoration-rect rect-1"></div>
            <div class="login-decoration-rect rect-2"></div>
        </div>
        
        <!-- 主卡片 -->
        <div class="login-card-container">
            <!-- 左侧描述区域 -->
            <div class="card-left">
                <div class="login-header">
                    <div class="login-logo">
                        <el-icon class="logo-icon"><DataBoard /></el-icon>
                    </div>
                    <div class="login-title">
                        <div class="title-main">MD-ECDATA</div>
                        <div class="title-sub">电商数据管理系统</div>
                    </div>
                </div>
                
                <div class="left-content">
                    <h2 class="welcome-text">欢迎使用电商数据管理平台</h2>
                    <p class="welcome-desc">集数据分析、营销策略、销售监控于一体的综合管理系统</p>
                    
                    <!-- 功能特性卡片 -->
                    <div class="feature-cards">
                        <div class="feature-card">
                            <div class="feature-icon">
                                <el-icon><DataAnalysis /></el-icon>
                            </div>
                            <div class="feature-text">
                                <h3>数据分析</h3>
                                <p>强大的数据分析工具，让决策更精准</p>
                            </div>
                        </div>
                        
                        <div class="feature-card">
                            <div class="feature-icon">
                                <el-icon><Monitor /></el-icon>
                            </div>
                            <div class="feature-text">
                                <h3>实时监控</h3>
                                <p>全面监控电商平台数据表现</p>
                            </div>
                        </div>
                        
                        <div class="feature-card">
                            <div class="feature-icon">
                                <el-icon><PieChart /></el-icon>
                            </div>
                            <div class="feature-text">
                                <h3>可视化报表</h3>
                                <p>直观的数据可视化，一目了然</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- 右侧登录区域 -->
            <div class="card-right">
                <div class="login-form-container">
                    <el-form :model="loginInfo" :rules="rules" ref="loginInfo">
                        <div class="form-header">
                            <div class="form-title">账号登录</div>
                            <el-button type="primary" class="help-btn" circle>?</el-button>
                        </div>
                        
                        <div class="form-body">
                            <el-form-item prop="userName">
                                <el-input 
                                    v-model="loginInfo.userName" 
                                    size="large" 
                                    placeholder="请输入账号ID" 
                                    :prefix-icon="Avatar"
                                    class="login-input"
                                /> 
                            </el-form-item>
                            
                            <el-form-item prop="password">
                                <el-input 
                                    type="password" 
                                    show-password 
                                    v-model="loginInfo.password" 
                                    size="large" 
                                    placeholder="请输入登录密码"  
                                    :prefix-icon="Lock"
                                    class="login-input"
                                /> 
                            </el-form-item>
                            
                            <div class="error-message" v-if="errorMsg">{{ errorMsg }}</div>
                            
                            <el-button 
                                type="primary" 
                                class="login-button" 
                                @click="login('loginInfo')"
                                :loading="loading"
                            >
                                登录
                            </el-button>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script >  
import {
    QuestionFilled, Avatar, Lock, View, Hide,
    DataAnalysis, Monitor, PieChart, Star, Calendar, DataBoard
} from '@element-plus/icons-vue'
import { asyncPostLoading } from '../api/request';  
import md5 from 'js-md5';
import UserStorage from '../api/UserStorage';

export default {
    name:"UserLogin",
    setup(){  
        return {
            QuestionFilled, Avatar, Lock, View, Hide,
            DataAnalysis, Monitor, PieChart, Star, Calendar, DataBoard
        } 
    },
    components:{
        QuestionFilled, Avatar, Lock, View, Hide,
        DataAnalysis, Monitor, PieChart, Star, Calendar, DataBoard
    },
    data:function(){
        return{
            loginInfo:{
                userName:'',
                password:''
            },
            errorMsg:'',
            loading: false,
            rules:{
                password:[
                    { required: true, min: 1, message: '请输入密码！', trigger: 'blur' }
                ],
                userName:[
                    { required: true,min:1,message: '请输入用户名！', trigger: 'blur' }
                ] 
            },   
        };
    },
    mounted() {
        // 绑定enter事件
        document.addEventListener("keyup", this.enterKey);
    },
    unmounted() {
        // 销毁enter事件
        document.removeEventListener("keyup", this.enterKey);
    },
    methods:{
        //打开开发商官网
        openUrl(url){
            window.open(url);
        },
        login(loginInfo){
            //触发表单验证 
            this.$refs[loginInfo].validate(valid => {
                if(!valid) return;
                //提交登录
                let param = {
                    "userName":this.loginInfo.userName,
                    "password":md5(this.loginInfo.password)
                };
                this.loading = true; 
               
                asyncPostLoading(this.$userURL + "/user/login",param,res => {
                    this.loading = false;
                            
                    if(res.data.head.st != 0){
                        this.errorMsg = res.data.head.msg; 
                        return;
                    }
                    this.$message.success('登录成功');
                    let data = res.data.body;
                    UserStorage.setUserInfo(data);

                    this.$router.push('/dashboard');
                },err => {
                    this.errorMsg = err;
                    this.loading = false;
                });  
            }); 
        },
        //监听回车
        enterKey(event) {
            const code = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode;
            if (code == 13) {
                this.login('loginInfo');
            }
        },
    }
}
</script>

<style scoped>
.login-container {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
    position: relative;
    overflow: hidden;
}

/* 背景装饰 */
.login-background {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
}

.login-decoration-circle {
    position: absolute;
    border-radius: 50%;
    background: linear-gradient(135deg, #4170FF 0%, #2E5BE0 100%);
    opacity: 0.6;
}

.circle-1 {
    width: 400px;
    height: 400px;
    left: -200px;
    top: -200px;
    animation: float 8s ease-in-out infinite;
}

.circle-2 {
    width: 300px;
    height: 300px;
    right: -150px;
    bottom: -150px;
    background: linear-gradient(135deg, #43A047 0%, #2E7D32 100%);
    animation: float 12s ease-in-out infinite reverse;
}

.circle-3 {
    width: 200px;
    height: 200px;
    left: 30%;
    bottom: -100px;
    background: linear-gradient(135deg, #FF5722 0%, #E64A19 100%);
    animation: float 10s ease-in-out infinite;
}

.login-decoration-rect {
    position: absolute;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    transform: rotate(45deg);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.rect-1 {
    width: 300px;
    height: 100px;
    top: 25%;
    left: 10%;
    animation: float 15s ease-in-out infinite;
}

.rect-2 {
    width: 200px;
    height: 200px;
    top: 60%;
    right: 15%;
    animation: float 18s ease-in-out infinite reverse;
}

@keyframes float {
    0% { transform: translateY(0) rotate(45deg); }
    50% { transform: translateY(-20px) rotate(45deg); }
    100% { transform: translateY(0) rotate(45deg); }
}

/* 主卡片容器 */
.login-card-container {
    display: flex;
    width: 80%;
    max-width: 1200px;
    height: 80vh;
    max-height: 700px;
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 10;
    overflow: hidden;
}

/* 左侧描述区域 */
.card-left {
    flex: 5;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
    border-radius: 20px 0 0 20px;
    padding: 40px;
    position: relative;
    z-index: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.login-header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
}

.login-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
}

.logo-icon {
    font-size: 40px;
    color: #4170FF;
    background: linear-gradient(135deg, #4170FF 0%, #2E5BE0 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 2px 4px rgba(65, 112, 255, 0.3));
}

.title-main {
    font-size: 20px;
    font-weight: 600;
    color: #333;
}

.title-sub {
    font-size: 14px;
    color: #666;
    margin-top: 4px;
}

.left-content {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.welcome-text {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin-bottom: 10px;
}

.welcome-desc {
    font-size: 15px;
    color: #666;
    margin-bottom: 30px;
}

.feature-cards {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.feature-card {
    display: flex;
    align-items: center;
    padding: 15px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.feature-card:hover {
    transform: translateX(5px);
    background: white;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.feature-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: linear-gradient(135deg, #4170FF 0%, #2E5BE0 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 20px;
    margin-right: 15px;
    flex-shrink: 0;
}
.feature-text{
    width: 300px;
}

.feature-text h3 {
    font-size: 15px;
    font-weight: 600;
    margin: 0 0 5px;
    color: #333;
}

.feature-text p {
    font-size: 13px;
    color: #666;
    margin: 0;
    line-height: 1.4;
}

.copyright {
    font-size: 12px;
    color: #999;
    margin-top: 20px;
    text-align: center;
}

/* 右侧登录区域 */
.card-right {
    flex: 5;
    background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0 20px 20px 0;
    position: relative;
    overflow: hidden;
}

/* 右侧装饰元素 */
.card-right::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 100%;
    height: 200%;
    background: linear-gradient(135deg, rgba(65, 112, 255, 0.03) 0%, rgba(65, 112, 255, 0.06) 100%);
    border-radius: 50%;
    z-index: 0;
}

/* 确保表单内容在装饰元素上层 */
.login-form-container {
    width: 75%;
    position: relative;
    z-index: 1;
}

.form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.form-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
}

.help-btn {
    width: 32px !important;
    height: 32px;
    font-size: 16px;
    padding: 0;
    background: #4170FF;
    transition: all 0.3s ease;
}

.help-btn:hover {
    transform: rotate(15deg);
    box-shadow: 0 4px 12px rgba(65, 112, 255, 0.3);
}

.login-input :deep(.el-input__wrapper) {
    border-radius: 8px;
    height: 48px;
    transition: all 0.3s ease;
}

.login-input :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px #4170FF inset;
}

.error-message {
    color: #F56C6C;
    font-size: 14px;
    margin: 10px 0;
    min-height: 20px;
}

.login-button {
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-weight: 500;
    background: linear-gradient(135deg, #4170FF 0%, #2E5BE0 100%);
    border: none;
    box-shadow: 0 4px 15px rgba(65, 112, 255, 0.3);
    border-radius: 8px;
    margin-top: 20px;
    transition: all 0.3s ease;
}

.login-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(65, 112, 255, 0.4);
}

.login-button:active {
    transform: translateY(0);
}

@media (max-width: 768px) {
    .card-left{
        display: none;
    }
    .login-card-container {
        width: 95%;
    }
    
    .card-left {
        min-height: 320px;
        padding: 25px;
    }
    
    .welcome-text {
        font-size: 22px;
    }
}

@media (max-width: 576px) {
    .card-left {
        min-height: 300px;
        padding: 20px 15px;
    }
    
    .welcome-text {
        font-size: 20px;
    }
    
    .feature-cards {
        grid-template-columns: 1fr;
    }
    
    .feature-card {
        margin-bottom: 10px;
    }
}

.feature-icon .el-icon {
    font-size: 20px;
}

/* 新增系统信息样式 */
.system-info {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    font-size: 12px;
    color: #666;
}

.info-item {
    display: flex;
    align-items: center;
    gap: 5px;
}

.info-item .el-icon {
    font-size: 14px;
    color: #4170FF;
}
</style>